import React from 'react';
import bemHelper from 'react-bem-helper';
import { Element } from 'react-scroll';

import analytics from '../analytics/analytics';
import analyticsStorefront from '../analytics/storefront';
import TopbarModule from '../components/TopbarModule/TopbarModule';
import IntroModule from '../components/IntroModule/IntroModule';
import OurStoryModule from '../components/OurStoryModule/OurStoryModule';
import BasicLayoutModule from '../components/AboutModule/AboutModule';
import ProductsModule from '../components/ProductsModule/ProductsModule';
import CommentsGrid from '../components/CommentsGrid/CommentsGrid';
import ReturnsModule from '../components/ReturnsModule/ReturnsModule';
import DeliveryModule from '../components/DeliveryModule/DeliveryModule';
import TermsAndConditionsModule from '../components/TermsAndConditionsModule/TermsAndConditionsModule';
import SocialShareSection from '../components/SocialShareSection/SocialShare';
import VatNumberModule from '../components/VatNumberModule/VatNumberModule';

const bem = bemHelper({ prefix: 'toga-', name: 'policies' });

class Storefront extends React.Component {

  componentDidMount() {
    analytics.setPartnerInfo({
      id: this.props.session.partnerId,
      name: this.props.session.partnerName,
    });
    analyticsStorefront.registryView();
  }

  render() {
    const { data, session } = this.props;
    const {
      introSection, storySection, otherSection, productsSection, menus, customersSection = {}
    } = data;

    const topReviews = customersSection.topReviews || {};
    const pressComments = customersSection.pressComments || {};
    const intro = introSection && introSection.intro;
    const termsAndConditions = (otherSection && otherSection.termsAndConditions) || {};
    const delivery = (otherSection && otherSection.delivery) || {};

    return (
      <div>
        <Element name="intro">
          {introSection && <IntroModule {...introSection.intro} />}
        </Element>

        <TopbarModule menus={menus} intro={intro}/>

        <Element name="our_story">
          {storySection && storySection.ourStory && <OurStoryModule {...storySection.ourStory} />}
          {storySection && storySection.who && <BasicLayoutModule {...storySection.who} />}
        </Element>

        {session && <SocialShareSection {...session }/>}

        <Element name="products">
          <ProductsModule {...productsSection} {...session}/>
        </Element>

        <Element name="press_comments">
          <CommentsGrid comments={pressComments.comments} reviews={topReviews.reviews}/>
        </Element>

        <Element name="policies" {...bem()}>
          <DeliveryModule {...delivery}/>
          {otherSection && otherSection.returns &&
          <ReturnsModule {...otherSection.returns}/>}
          <TermsAndConditionsModule {...termsAndConditions}/>
          {otherSection && otherSection.vat_number &&
          <VatNumberModule vatNumber={otherSection.vat_number}/>}
        </Element>

      </div>
    );
  }
}

Storefront.propTypes = {};

export default Storefront;



// WEBPACK FOOTER //
// ./src/components/storefront/containers/Storefront.js